import {
    ContextualMenu, DefaultButton, getId, Icon, IContextualMenuProps, IDragOptions,
    Modal, PrimaryButton, ProgressIndicator, TextField
} from "@fluentui/react";
import { BasicDatePicker } from "../../common/views/BasicDatePicker";
import { defaultButtonStyles, primaryButtonStyles, textFieldStyles } from "../../common/views/DefaultStyles";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { NewFeedEntryModel } from "../models/NewFeedModel";

type NewFeedEntryProps = {
    isEdit: boolean;
    form: NewFeedEntryModel;
    loading: boolean;
    onValueChange: (field: keyof NewFeedEntryModel, value: any) => void;
    onClose: (refresh: boolean) => void;
    onEdit: () => void;
    onCreate: () => void;
}

export default function NewFeedEntryView({
    isEdit, form, onValueChange, loading, onClose, onEdit, onCreate
}: NewFeedEntryProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };
    const commandMenuProps: IContextualMenuProps = {
        shouldFocusOnMount: true,
        items: []
    };

    const width2 = Utils.getColumnWidth(2);
    const width6 = Utils.getColumnWidth(6);
    const width10 = Utils.getColumnWidth(10);

    const onSubmit = () => {
        if (isEdit) {
            onEdit();
        } else {
            onCreate();
        }
    }

    const modalHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}>
                    <b>{isEdit ? "Edit New Feed " + form.id : "Add New Feed"}</b>
                </div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={() => onClose(false)}
                    />
                </div>
            </div>
        </div>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row ph-10">
            <div className={width6}>
                <DefaultButton
                    onClick={() => onClose(false)}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const brandInput = () => {
        return <>
            <TextField
                label="Brand"
                value={form.brand}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("brand", v || "")} />
        </>;
    }

    const titleInput = () => {
        return <>
            <TextField
                label="Title"
                value={form.title}
                styles={textFieldStyles}
                multiline={true}
                rows={2}
                onChange={(_, v) => onValueChange("title", v || "")} />
        </>;
    }

    const descriptionInput = () => {
        return <>
            <TextField
                label="Description"
                value={form.description}
                styles={textFieldStyles}
                multiline={true}
                rows={2}
                onChange={(_, v) => onValueChange("description", v || "")} />
        </>;
    }

    const urlInput = () => {
        return <>
            <TextField
                label="URL"
                value={form.url}
                styles={textFieldStyles}
                multiline={true}
                rows={2}
                onChange={(_, v) => onValueChange("url", v || "")} />
        </>;
    }

    const startDatePicker = () => {
        return <>
            <BasicDatePicker args={{
                label: "Start Date",
                onSelectDate: (date) => onValueChange("start", date),
                value: form.start
            }} />
        </>;
    }

    const endDatePicker = () => {
        return <>
            <BasicDatePicker args={{
                label: "End Date",
                onSelectDate: (date) => onValueChange("end", date),
                value: form.end
            }} />
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={() => onClose(false)}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <div className="popup-header">
                {modalHeader()}
            </div>
            <div id={subtitleId} className="popup-body">
                <div className="ph-10">
                    <div>{brandInput()}</div>
                    <div className="pt-10">{titleInput()}</div>
                    <div className="pt-10">{descriptionInput()}</div>
                    <div className="pt-10">{urlInput()}</div>

                    <div className="ms-Grid-row pt-10">
                        <div className={width6}>{startDatePicker()}</div>
                        <div className={width6}>{endDatePicker()}</div>

                    </div>

                    {!loading && <div className="ms-Grid-row center pv-20">
                        {buttons()}
                    </div>}

                    {loading && <div className="pv-20">
                        <ProgressIndicator label="Submitting" description="" />
                    </div>}
                </div>
            </div>
        </Modal>
    </>;
}